// extracted by mini-css-extract-plugin
module.exports = {"login":"Login_login__2TRVV","wrapper":"Login_wrapper__3sJ_p","push":"Login_push__CGGTj","footer":"Login_footer__5KcRp"};